































export default {
    data() {
        return {
            currentPlate: '',
            currentPage: '',
        };
    },
    props: ['plate'],
    computed: {
        isVehicle(this: any) { return this.currentPage === 'vehicle'; },
        isRoute(this: any) { return this.currentPage === 'route'; },
        isAll(this: any) { return this.currentPage === 'vehicle_all'; },
    },
    components: {},
    methods: {},
    mounted(this: any) {
        this.currentPage = this.$route.name;
    },
};
